import styled, { css } from "styled-components";
import { Box, Flex, DashPlaceholder, Text, Thumbnail } from "dash-ui";

const imageCss = css`
  width: 100%;
  height: 100%;
  border-radius: 8px 8px 0 0;
`;

export const ImageContainer = styled(Box)`
  position: relative;

  :hover {
    & > div:first-child {
      display: flex;
    }
  }
`;
export const StyledImage = styled(Thumbnail)`
  ${imageCss}
`;

export const StyledDashPlaceholder = styled(DashPlaceholder)`
  ${imageCss}
`;

export const StyledHideDashPlaceholder = styled(DashPlaceholder)`
  ${imageCss}
  background-color: ${({ theme }) =>
    theme.colors.setOpacity(theme.colors.n30, 30)};
  position: absolute;
  top: 0px;
`;

export const StyledWrapper = styled(Box)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  border-radius: 8px;
  cursor: pointer;
`;

export const StyledText = styled(Text)<{ clamp: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ clamp }) => clamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VerifiedBadgeWrapper = styled(Flex)`
  position: absolute;
  top: ${({ theme }) => theme.space * 3}px;
  left: ${({ theme }) => theme.space * 3}px;
  z-index: 1;
`;

export const MainContent = styled(Flex)<{
  isSubscriptionActive?: boolean | null;
  isPropertyAccessible?: boolean | null;
}>`
  ${({ isSubscriptionActive, isPropertyAccessible }) =>
    !isPropertyAccessible && !isSubscriptionActive
      ? css`
          -moz-filter: blur(5px);
          -o-filter: blur(5px);
          -ms-filter: blur(5px);
          filter: blur(5px);
          -webkit-user-select: none;
          -ms-user-select: none;
          user-select: none;
        `
      : ""}
`;
